import { renderEmailPreviewHtml } from "@/lib/emailPreview";

export const EmailPreviewFrame = ({
  subject,
  heading,
  bodyHtml,
  includeMarketingFooter = false,
  includeAutomatedFooter = true,
  testId = "email-preview-frame",
}) => (
  <div className="overflow-hidden rounded-2xl border border-gray-100 bg-slate-50 shadow-inner">
    <iframe
      title="Email preview"
      srcDoc={renderEmailPreviewHtml({ subject, heading, bodyHtml, includeMarketingFooter, includeAutomatedFooter })}
      sandbox=""
      className="h-[560px] w-full bg-slate-50"
      data-testid={testId}
    />
  </div>
);
